import * as React from 'react';
import NodeQuery from '../../../../QueryComponents/NodeQuery/NodeQuery';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { getAttributeInfo } from '../../../../../Model/avenyModelUtils';
import { getValueFromDotPath } from '../../../../../Utils/dataUtils';
import { ModelContext } from '../../../../../Model/ModelContext/ModelContext';
import EditableAttribute from '../../../EditableAttribute/EditableAttribute';
import { headerColumns } from '../../../../../Features/Delsystem/_Common/Utils/defaultColumns';

interface IProps {
  collection: IClientBusinessModel;
  /** Dot delimited path to the attribute, can also be just the attribute name.
   Should always end on an attribute name (ex: associationName1.associationName2.attributeName) */
  attributePath: string;
  objectId: string | null;
}

/**
 * Implementation av ClickEditableAttributeValue med värden hämtade från ett attribut i collection.
 */
class ConnectedAttributeField extends React.Component<IProps> {
  static contextType = ModelContext;
  declare context: React.ContextType<typeof ModelContext>;

  render() {
    const attributeInfo = getAttributeInfo(
      this.props.collection,
      this.props.attributePath,
      this.context.avenyCollectionMap
    );

    const { attribute } = attributeInfo;

    const isHeader = Boolean(
      headerColumns(this.props.collection.CollectionName).find(
        x => x.attributeDef === this.props.attributePath
      )
    );
    return (
      <NodeQuery
        key={this.props.attributePath}
        collectionName={this.props.collection.CollectionName}
        id={this.props.objectId}
        fieldDefs={[this.props.attributePath]}
      >
        {(loading, data) => (
          <EditableAttribute
            collection={this.props.collection}
            attribute={attribute}
            value={getValueFromDotPath(data, this.props.attributePath)}
            label={attribute.DisplayLabel}
            editMode={false} // Konstant läsläge tills en formContext utarbetats.
            disabled={!attribute.GUIEditable}
            onChange={() => {}}
            size="medium"
            header={isHeader}
          />
        )}
      </NodeQuery>
    );
  }
}

export default ConnectedAttributeField;
